import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {StarIcon} from 'shells/icon';

import styles from './winner-badge.module.css';

type Props = {
    removeMargin?: boolean;
    // Text is either 'Winning…' or 'Winner'
    isWinner: boolean;
};

export function WinnerBadge(props: Props) {
    return (
        <div style={{marginLeft: props.removeMargin ? 0 : 8}} className={styles['winner-badge']}>
            {/* @ts-expect-error */}
            <StarIcon size={11} color={colors.white} />
            {props.isWinner ? 'Winner' : 'Winning…'}
        </div>
    );
}
